import React, { useState, useRef } from 'react';

const Mobilefooterbtn = () => {
  const [activeDrawer, setActiveDrawer] = useState(null); // "whatsapp", "call", or null
  const startYRef = useRef(null);

  // Swipe-to-close handlers
  const handleTouchStart = (e) => {
    startYRef.current = e.touches[0].clientY;
  };

  const handleTouchMove = (e) => {
    if (startYRef.current === null) return;
    const currentY = e.touches[0].clientY;
    const deltaY = currentY - startYRef.current;

    if (deltaY > 60) {
      setActiveDrawer(null);
      startYRef.current = null;
    }
  };

  const isDrawerOpen = activeDrawer !== null;

  return (
    <>
      {/* Fixed Bottom Buttons */}
      <div className="d-md-none fixed-bottom bg-white border-top py-2 px-4 d-flex justify-content-around">
        <button
          onClick={() => setActiveDrawer('whatsapp')}
          className="btn btn-success rounded-circle d-flex align-items-center justify-content-center"
          style={{ width: '56px', height: '56px' }}
        >
          <i className="bi bi-whatsapp fs-4"></i>
        </button>

        <button
          onClick={() => setActiveDrawer('call')}
          className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center"
          style={{ width: '56px', height: '56px' }}
        >
          <i className="bi bi-telephone-fill fs-4"></i>
        </button>
      </div>

      {/* Overlay */}
      {isDrawerOpen && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
          style={{ zIndex: 1049 }}
          onClick={() => setActiveDrawer(null)}
        ></div>
      )}

      {/* WhatsApp Drawer - Bottom Left 50% */}
      <div
        className="d-md-none position-fixed bottom-0 start-0 bg-light border-top p-3 shadow-lg"
        style={{
          width: '50vw',
          height: '200px',
          zIndex: 1050,
          transition: 'transform 0.3s ease-in-out',
          transform:
            activeDrawer === 'whatsapp' ? 'translateY(0)' : 'translateY(100%)',
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
      >
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">Chat Now</h5>
          <button
            className="btn-close"
            onClick={() => setActiveDrawer(null)}
          >
          </button>
        </div>
        {/* <p>This is WhatsApp drawer content.</p> */}
        <a href="https://wa.me/919766439090?text=Hello%2C%20Can%20I%20know%20more%20about%20Fortune%20Cloud%20Institute%3F" target="_blank" rel="noopener noreferrer" className="w-100">
            <img src="/assets/images/icons/wp1.png" alt="Logo" className="img-fluid mb-2" />
        </a>
        <a href="https://wa.me/918002949090?text=Hello%2C%20Can%20I%20know%20more%20about%20Fortune%20Cloud%20Institute%3F" target="_blank" rel="noopener noreferrer" className="w-100">
            <img src="/assets/images/icons/wp2.png" alt="Logo" className="img-fluid mb-2" />
        </a>
        <a href="https://wa.me/917090119090?text=Hello%2C%20Can%20I%20know%20more%20about%20Fortune%20Cloud%20Institute%3F" target="_blank" rel="noopener noreferrer" className="w-100">
            <img src="/assets/images/icons/wp3.png" alt="Logo" className="img-fluid mb-2" />
        </a>
      </div>

      {/* Call Drawer - Bottom Right 50% */}
      <div
        className="d-md-none position-fixed bottom-0 end-0 bg-light border-top p-3 shadow-lg"
        style={{
          width: '50vw',
          height: '200px',
          zIndex: 1050,
          transition: 'transform 0.3s ease-in-out',
          transform:
            activeDrawer === 'call' ? 'translateY(0)' : 'translateY(100%)',
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
      >
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">Call Us</h5>
          <button
            className="btn-close"
            onClick={() => setActiveDrawer(null)}
          >
            
          </button>
        </div>
        {/* <p>You can reach our support team via phone.</p> */}
        <a href="tel:9766439090" className="w-100">
          <img src="/assets/images/icons/call1.png" alt="Logo" className="img-fluid mb-2" />
        </a>
        <a href="tel:8002949090" className="w-100">
          <img src="/assets/images/icons/call2.png" alt="Logo" className="img-fluid mb-2" />
        </a>
        <a href="tel:7090119090" className="w-100">
          <img src="/assets/images/icons/call3.png" alt="Logo" className="img-fluid mb-2" />
        </a>
      </div>
    </>
  );
};

export default Mobilefooterbtn;
